import { render, staticRenderFns } from "./ArticleAdd.vue?vue&type=template&id=e01e2278&scoped=true&"
import script from "./ArticleAdd.vue?vue&type=script&lang=js&"
export * from "./ArticleAdd.vue?vue&type=script&lang=js&"
import style0 from "./ArticleAdd.vue?vue&type=style&index=0&id=e01e2278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01e2278",
  null
  
)

export default component.exports